import React, { useCallback, useRef } from 'react';
import { FieldArray } from 'react-final-form-arrays';

import FieldGroup from 'Shared/components/FormComponents/FieldGroup/FieldGroup';

import CheckboxItem from '../../../DesktopOnboardingWizard/CheckboxItem/CheckboxItem';
import AddMoreTopicsButton from '../../../DesktopOnboardingWizard/DiscussionTopics/AddMoreTopicsButton/AddMoreTopicsButton';
import './FormFields.scss';

function topicsValidate(values) {
  if (values.some(item => item.checked)) return undefined;
  return 'Required field';
}

function FormFields() {
  const ref = useRef(null);

  const handleAddMoreClick = useCallback(() => {
    const node = ref.current;
    if (node) node.focus();
  }, []);

  return (
    <FieldGroup
      label="What topics should we add to all of the workspace(s)?"
      labelClassName="onboarding-mobile-form-label pt-3 mb-3"
    >
      <div className="mb-3">
        <FieldArray name="discussionTopics" validate={topicsValidate}>
          {({ fields }) =>
            fields.map((name, index) => (
              <CheckboxItem
                innerRef={index === fields.value.length - 1 ? ref : null}
                index={index}
                key={name}
                name={name}
                remove={fields.remove}
                placeholder="Enter discussion topic"
                bigSize
              />
            ))
          }
        </FieldArray>
      </div>
      <AddMoreTopicsButton onClick={handleAddMoreClick} />
    </FieldGroup>
  );
}

export default FormFields;
